import Api from "../../index"
import { requestType,endPoints } from "../../../constants/variables"


export const sendEmail=params=>{
    return Api(endPoints.sendEmail,params,requestType.POST);
}
export const saveImage=params=>{
    return Api(endPoints.saveImage,params,requestType.POST);
}